// eslint-disable-next-line no-unused-vars
const analyticsTypes = require('../jsdoc-types');
const {
  HashmapStorageFactory,
  HASHMAP_STORAGE_TYPE,
} = require('../../common/utils/hashmapStorage');

const searchDataStorage = HashmapStorageFactory.createHashmapStorage({
  type: HASHMAP_STORAGE_TYPE.LOCAL_STORAGE,
  name: 'ga.searchData',
});

const searchDataOfCartItemsStorage = HashmapStorageFactory.createHashmapStorage(
  {
    type: HASHMAP_STORAGE_TYPE.LOCAL_STORAGE,
    name: 'ga.searchDataOfCartItems',
  }
);

module.exports = {
  searchDataOfCartItemsStorage,
  searchDataStorage,
};
